<template>
  <div>
        
    <div
      aria-hidden="true"
      class="modal fade"
      id="solicitudesCorreccionModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div
          class="modal-content color-scheme-light"
          style="width: 100%; max-width: 100%"
        >
          <div class="modal-header faded smaller">
            <h5 class="text-success modal-title">Solicitudes por corrección para corte de caja </h5>
            <br>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="element-wrapper">
              <div class="element-actions actions-only"></div>
              <div class="element-box-tp" style="padding: 0em !important">
                <table class="table table-compact smaller mb-0">
                  <thead>
                    <tr>
                      <th>Tienda</th>
                      <th class="text-center">Número</th>
                      <th class="text-center">Fecha de creación</th>
                      <th class="text-center">Motivo</th>
                      <th class="text-center">Tipo de Detalle</th>
                      <th class="text-center">Tipo de Corrección</th>
                      <th class="text-center">Forma de Pago</th>
                      <th class="text-center">Cantidad</th>
                      <th class="text-center">Caja</th>
                      <th>Cajero</th>
                      <th>Usuario Acepta</th>
                      <th>Estado</th>
                      <th colspan="2" class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="solicitud in solicitudes">
                      <td>{{ solicitud.tienda.nombre }}</td>
                      <td class="text-center">{{ solicitud.numero }}</td>
                      <td>{{ solicitud.fecha_creacion | moment("DD/MM/YYYY HH:MM") }}</td>
                      <td>{{ solicitud.motivo }}</td>
                      <td class="text-center">{{ solicitud.tipo_detalle_corte }}</td>
                      <td class="text-center">{{ solicitud.tipo_correccion }}</td>
                      <td class="text-center">{{ solicitud.forma_pago.nombre }}</td>
                      <td class="text-center">Q {{ solicitud.cantidad }}</td>
                      <td class="text-center">{{ solicitud.caja.numero }}</td>
                      <td>{{ solicitud.cajero.username }}</td>
                      <td v-if="solicitud.encargado">{{ solicitud.encargado.username }}</td>
                      <td v-else></td>
                      <td class="text-center">
                        <div
                          :class="{
                            'status-pill yellow':solicitud.estado === 'A',
                            'status-pill green':solicitud.estado === 'B',
                            'status-pill red':solicitud.estado === '9',
                          }"
                          :data-title="{
                            'Activo':solicitud.estado === 'A',
                            'Aceptado':solicitud.estado === 'B',
                            'Anulado':solicitud.estado === '9',
                          }"
                          data-toggle="tooltip"
                        ></div>
                      </td>
                      <td class="text-center" v-if="solicitud.estado === 'A' && encargado.confirmado">
                        <a @click="aceptar(solicitud)"><i class="fas fa-check" style="color:green"></i></a>
                      </td>
                      <td class="text-center" v-else>
                      </td>
                      <td class="text-center" v-if="solicitud.estado === 'A' && encargado.confirmado">
                        <a @click="anular(solicitud)"><i class="fas fa-times" style="color:red"></i></a>
                      </td>
                      <td class="text-center" v-else>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <small
                  style="color: gray" class="font-weight-bold"
                > Estados de las solicitudes:
                  <div v-for="estado in estados">
                    <div
                      :class="{
                        'status-pill yellow':estado.llave === 'A',
                        'status-pill green':estado.llave === 'B',
                        'status-pill red':estado.llave === '9',
                      }"
                      data-title="Anulado"
                      data-toggle="tooltip"
                    ></div>
                      {{estado.valor}}
                  </div>
                </small><br>
                <small style="color: gray" class="font-weight-bold"
                >Tomar en cuenta lo siguiente:
                  <br>
                  <i style="color: gray" class="fas fa-info-circle"></i>
                  Para poder realizar cualquier acción sobre la solicitud debe validar
                  primero su usuario, el cuál debe tener permisos especiales.
                  <br />
                  <i style="color: gray" class="fas fa-info-circle"></i>
                  En caso su usuario si debe poder realizar cambios pero no cuente con los permisos deberá notificarlo.
                </small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="encargado.confirmado === false"
              class="btn btn-info"
              @click="verModalSesion()"
            >
              Validar usuario
            </button>
            <button
              class="btn btn-warning"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="usuarioAceptaModal" tabindex="-1" aria-labelledby="usuarioAceptaModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="usuarioAceptaModalLabel">Usuario de confirmación</h1>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="recipient-name" class="col-form-label">Usuario:</label>
                <input type="text" class="form-control" v-model="encargado.username">
              </div>
              <div class="mb-3">
                <label for="message-text" class="col-form-label">Contraseña:</label>
                <input type="password" class="form-control" v-model="encargado.password">
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="validarSesion()"
            >
              Confirmar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import DynamicService from "@/services/commons/DynamicService";
  import AuthService from "@/services/AuthService";
  import Notifications from "@/notifications/notifications";
  import SolicitudCorreccionService from "@/services/cxc/SolicitudCorreccionService";
import { status } from "nprogress";
  
  export default {
    props: ["solicitudes","estados","permisos"],
    data() {
        return {
          solicitud:null,
          encargado:{
            id:null,
            username:null,
            password:null,
            is_superuser:false,
            grupos:null,
            confirmado:false,
            fechaLogin:null,
          },
          fechaActual:null,
          errors: {
            username: [],
            password: [],
            non_field_errors: []
          }
        };
    },
    computed: {
    },
    mounted() {
      
    },
    methods: {
      refresh() {
        // Emitir el evento para notificar al padre
        this.$emit('refreshSolicitudes');
        this.$emit('refreshCurrent');
      },
      verModalSesion(){
        $('#usuarioAceptaModal').modal('show');
      },
      async validarSesion(){
        let self = this;
        await AuthService.login({
        username: this.encargado.username,
        password: this.encargado.password
      })
        .then(res => {
          if(res.status === 200){
            self.encargado.grupos = res.data.grupos;
            self.encargado.confirmado = self.encargado.grupos.some(grupo => grupo.id === self.permisos.SUBJEFES_ASISTENTES || grupo.id === self.permisos.JEFES || grupo.id === self.permisos.ADMINISTRADOR);
            if(self.encargado.confirmado === false){self.$toast.warning("Permisos restringidos", "No tiene los permisos necesarios para realizar la acción.", {position: 'topRight'});return;}
            self.encargado.id = res.data.id;
            self.encargado.is_superuser = res.data.is_superuser;
            self.encargado.username = null;
            self.encargado.password = null;
            self.encargado.fechaLogin = new Date();
            $('#usuarioAceptaModal').modal('hide');
          }
        })
        .catch(err => {
          if (err.response && err.response.data) {
            self.errors.username = [];
            self.errors.password = [];
            self.errors.non_field_errors = err.response.data.non_field_errors || [];
            self.$toast.warning(" Revise sus Credenciales", self.errors.non_field_errors.toString(), {
              position: 'topRight'
            });
          }
        });
      },
      aceptar(current){
        let self = this;
        let detail = "";
        if(self.verificarTiempo()){return;}
        Notifications.alert.confirm(
          "Aceptar solicitud",
          "Se aceptará la solicitud, ¿Esta seguro que desea continuar?",
          " ",
          function () {
            SolicitudCorreccionService.postAction(
              current.id,
              "aceptar",
              {encargado:self.encargado.id}
            )
             .then((response) => {
              detail = response.data.detail;
                Notifications.alert.success(
                  "Aceptar solicitud",
                  detail
                );
                self.refresh();
              })
             .catch((errors) => {
                if (errors.response) {
                  Notifications.alert.error(
                    "Aceptar solicitud",
                    errors.response.data.detail
                  );
                }
              });
          }
        );
      },
      anular(current) {
        let self = this;
        if(self.verificarTiempo()){return;}
        Notifications.alert.confirm(
        "Anular solicitud",
        "Se anulará la solicitud, ¿Esta seguro que desea continuar?",
        " ",
        function () {
          SolicitudCorreccionService.postAction(
            current.id,
            "anular",
            {encargado:self.encargado.id}
          )
            .then((response) => {
              Notifications.alert.success(
                "Anular solicitud",
                "Se ha anulado satisfactoriamente"
              );
              self.refresh();
            })
            .catch((errors) => {
              if (errors.response) {
                Notifications.alert.error(
                  "Anular solicitud",
                  errors.response.data.detail
                );
              }
            });
          }
        );
      },
      verificarTiempo(){
        const ahora = new Date(); // Fecha y hora actual

        // Convertir fecha guardada a objeto Date (si es un string)
        const fechaGuardadaObj = new Date(this.encargado.fechaLogin);

        // Calcular 3 minutos después de la fecha guardada
        const tresMinutosDespues = new Date(fechaGuardadaObj.getTime() + 1 * 60 * 1000);

        if (ahora > tresMinutosDespues) {
            this.$toast.warning("El tiempo límite de 1 minuto se excedió, debe volver a validar su usuario", this.errors.non_field_errors.toString(), {
              position: 'topRight'
            });
            this.limpiarSesion();
            return true;
            // Aquí puedes realizar una acción específica
        }
        return false;
      },
      limpiarSesion(){
        this.encargado.id=null;
        this.encargado.username=null;
        this.encargado.password=null;
        this.encargado.is_superuser=false;
        this.encargado.grupos=null;
        this.encargado.confirmado=false;
        this.encargado.fechaLogin=null;
      },
    },
  };
  </script>
  